import React from "react";
import { Link } from "react-router-dom";

export const FeatureThreeItem = ({ feature }) => {
  return (
    <Link to={feature.href ?? "#"} className="link-btn" target={feature.href && "_blank"}>
      <div className="features-item-three">
        <div className="features-icon-three">
          <i className="flaticon-inspiration"></i>
        </div>
        <div className="features-content-three">
          <h2 className="title">{feature.title}</h2>
          <p>{feature.subtitle}</p>
          {feature.href && (
            <div className="link-btn">
              Visit Website <img src={feature.src} alt="ajinkya's-website" />
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};
